export const getApiMultipartFormDataHeadersConfig = () => {
  return {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
};
